import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFarrow } from '@/components/UI/svg/river2';
import { getImageSpec } from '@/utils/locals';

export default function O() {
    const { useEffect, useState, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('productriver2.river2.details');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['cn', 'jp', 'uk', 'de', 'fr', 'es', 'it', 'eu', 'za', 'au']);
    const [winW, setWinW] = useState(375);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setWinW(window?.innerWidth);
            getCardContentLength();
        }
    }, []);

    const [swiper, setSwiper] = useState({ activeIndex: 0 });
    const [active, setActive] = useState(0);

    const onSlideChange = (swiper: any) => {
        setActive(swiper?.realIndex || swiper.activeIndex % 3);
    };
    const onPrev = () => {
        const preIndex = swiper?.realIndex - 1;
        swiper?.slideToLoop(preIndex < 0 ? 2 : preIndex);
        setActive(swiper?.realIndex);
    };
    const onNext = () => {
        const nextIndex = (swiper?.realIndex + 1) % 3;
        swiper?.slideToLoop(nextIndex);
        setActive(swiper?.realIndex);
    };

    // 暂定最多是4条, 根据站点截取
    const descCards = [
        {
            desc: t('sec15_item_1_desc'),
            title: t('sec15_item_1_title'),
        },
        {
            desc: t('sec15_item_2_desc'),
            title: t('sec15_item_2_title'),
        },
        {
            desc: t('sec15_item_3_desc'),
            title: t('sec15_item_3_title'),
        },
        {
            desc: t('sec15_item_4_desc'),
            title: t('sec15_item_4_title'),
        },
    ];

    const getCardContent = () => {
        switch (locale) {
            case 'us':
            case 'ca':
            case 'za':
            case 'jp':
            case 'es':
            case 'it':
                return {
                    content: descCards.splice(0, 2),
                    page: [1, 2],
                };
            case 'uk':
            case 'eu':
            case 'de':
            case 'fr':
            case 'cn':
            case 'ph':
                return {
                    content: descCards.splice(0, 3),
                    page: [1, 2, 3],
                };
            default:
                return {
                    content: descCards.splice(0, 2),
                    page: [1, 2],
                };
        }
    };

    const getCardContentLength = () => {
        if (getCardContent()?.length > 2) {
            return [1, 2, 3];
        }
        return [1, 2];
    };

    return (
        <div className={`river2_details_O ${css.O_15}`}>
            <div className="bgImg">
                <div className="innerBox">
                    <p className="title">{t('sec15_title')}</p>
                    <p className="desc">
                        {t.rich('sec15_subtitle', {
                            p1: (child: any) => <span className="white">{child}</span>,
                        })}
                    </p>
                    <div className="swiperBox">
                        <Swiper
                            className={`river2_deatails_D_swiper`}
                            slidesPerView={'auto'}
                            spaceBetween={(winW / 375) * 15}
                            initialSlide={0}
                            preloadImages={false}
                            lazy
                            loop={true}
                            centeredSlides
                            grabCursor
                            onSwiper={(swiper: any) => setSwiper(swiper)}
                            onSlideChange={(swiper: any) => onSlideChange(swiper)}
                        >
                            {getCardContent().content.map((item, index: number) => (
                                <SwiperSlide key={index}>
                                    <div className="content">
                                        <div className="desc-popular">{item.desc}</div>
                                        <div className="title-popular">{item.title}</div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <ul className="paginations">
                            {getCardContent().page.map((_item: any, k: number) => (
                                <li className={`pagination-item ${k === active ? 'active' : ''}`} key={k}></li>
                            ))}
                        </ul>
                        <div className="swiper-btns">
                            <span className="pageBtn prev" onClick={onPrev}>
                                <EFarrow fill="rgba(255, 255, 255, 0.3)" />
                            </span>
                            <span className="pageBtn next" onClick={onNext}>
                                <EFarrow fill="rgba(255, 255, 255, 0.3)" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
